import { type FC, useCallback, type KeyboardEvent, useEffect, useRef } from 'react';
import { cn } from '../../utils/ui';
export interface ContenteditableProps {
    value: string;
    onInput: (value: string) => void;
    onKeyDown?: (e: KeyboardEvent<HTMLDivElement>) => void;
    onBlur?: () => void;
    className?: string;
}

const Contenteditable: FC<ContenteditableProps> = props => {
    const { value, onInput, onBlur, onKeyDown, className = '' } = props;
    const contentEditableRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!contentEditableRef.current) return;
        if (contentEditableRef.current.textContent === value) return;

        // Control the content
        contentEditableRef.current.textContent = value;
        contentEditableRef.current.focus();
        moveCursorToEnd(contentEditableRef.current);
    }, [value]);

    const moveCursorToEnd = (el: HTMLDivElement) => {
        const range = document.createRange();
        const selection = window.getSelection();
        range.selectNodeContents(el);
        range.collapse(false);
        selection?.removeAllRanges();
        selection?.addRange(range);
    };

    const handleInput = useCallback(e => {
        const textContent = e.target.textContent;
        onInput(textContent);
    }, []);

    return <div contentEditable="plaintext-only" ref={contentEditableRef} className={cn('cursor-auto', className)} onInput={handleInput} onBlur={onBlur} onKeyDown={onKeyDown} />;
};

export default Contenteditable;
